import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { Textarea } from "../components/ui/textarea"

export function TextareaRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()
  const placeholder = element.placeholder ? String(resolveSymbol(element.placeholder) ?? "") : undefined
  const value = element.text ? String(resolveSymbol(element.text) ?? "") : undefined

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    dispatchEvent(element.id, "change", { value: e.target.value })
  }

  return (
    <Textarea
      className={element.className}
      placeholder={placeholder}
      defaultValue={value}
      onChange={handleChange}
      data-testid={`textarea-${element.id}`}
    />
  )
}
